import Icon from '@bedrock/icons-react';
import { IconComponentProps } from '@bedrock/icons-react/lib/components/Icon';
import React from 'react';

const XingTu = (props: any) => {
  return (
    <svg
      {...props}
      width="14"
      height="14"
      viewBox="0 0 14 14"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <g>
        <path
          d="M0.839844 11.705L13.1598 3.00999L11.1278 11.705H0.839844Z"
          fill="#00F7EF"
        />
        <path
          d="M2.58691 3.35748L4.71997 11.705H12.7749L2.58691 3.35748Z"
          fill="#FE346E"
        />
      </g>
    </svg>
  );
};

export const XingTuIcon = (props: IconComponentProps) => {
  return <Icon component={XingTu} {...props} />;
};

export default XingTuIcon;
